import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Box, Glyph } from "@edreamsodigeo/prisma-design-system";
const GoBackArrow = ({
  onClick,
  isFindBooking
}) => {
  const {
    t
  } = useTranslation();
  return isFindBooking ? /*#__PURE__*/React.createElement(Box, {
    role: "button",
    onClick: onClick,
    "aria-label": t("mytripslogin.managebookings.findbooking.header.back"),
    mb: "base",
    sx: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Glyph, {
    category: "Arrows",
    name: "Left",
    size: "medium",
    color: "neutral.80"
  })) : null;
};
export default GoBackArrow;